import { useEffect } from 'react'
import { getEchoClient } from './echoClient'
import { useNotificationsStore } from '@/stores/notificationsStore'
import type { AppNotification } from '@/types/notifications'

interface NotificationReadEvent {
  id: string
  read_at: string
}

interface NotificationsMarkedReadEvent {
  read_at: string
}

export function useNotificationRealtime(userId: number | null): void {
  const receiveCreated = useNotificationsStore((state) => state.receiveCreated)
  const receiveRead = useNotificationsStore((state) => state.receiveRead)
  const receiveAllRead = useNotificationsStore((state) => state.receiveAllRead)

  useEffect(() => {
    if (!userId) return

    const echo = getEchoClient()
    const channelName = `user.${userId}.notifications`
    const channel = echo.private(channelName)

    channel.listen('.notification.created', (event: AppNotification) => {
      receiveCreated(event)
    })
    channel.listen('.notification.read', (event: NotificationReadEvent) => {
      receiveRead(event.id, event.read_at)
    })
    channel.listen('.notifications.marked-read', (event: NotificationsMarkedReadEvent) => {
      receiveAllRead(event.read_at)
    })

    return () => {
      echo.leave(channelName)
    }
  }, [receiveAllRead, receiveCreated, receiveRead, userId])
}
